// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-items {
  padding: 1rem calc(.5rem) 1rem 1rem;
  margin: 0;
  font-weight: 700;
  list-style-type: none;
}

  .dropdown-menu-items .dropdown-menu-items {
    padding: 0;
    margin-bottom: calc(.25rem);
    font-weight: 400;
  }

.dropdown-menu-item:not(.dropdown-menu-item:first-child) {
    margin-top: calc(.5rem);
  }

.dropdown-menu-item__link {
    display: block;
    padding-left: calc(.5rem);
    color: #424242;
    -webkit-text-decoration: none;
    text-decoration: none;
    cursor: pointer;
  }

.dropdown-menu-item__link:hover {
      -webkit-text-decoration: underline;
      text-decoration: underline;
    }

.dropdown-menu-item--active > a {
      color: #206dd2;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
